<template>
    <form class="former" @submit.prevent="action">
        <slot></slot>

        <span v-if="errorMessage" class="former__error">
            {{ errorMessage }}
        </span>

        <div v-if="gdprOptions" class="former__gdpr">
            <p
                v-for="(key, index) in Object.keys(gdprOptions)"
                :key="index"
                class="former__gdpr__pf"
                v-html="gdprOptions[key]"
            >
            </p>
        </div>

        <div v-if="agreeOptions" class="former__agree">
            <form-checkbox
                v-model="agreeOptions.value"
                :label="agreeOptions.label"
                @update:modelValue="agreeChange"
            />
        </div>

        <div
            class="former__btn"
            :class="{
                'former__btn--left': alignButton === 'left',
                'former__btn--center': alignButton === 'center',
                'former__btn--right': alignButton === 'right',
            }"
        >
            <button
                type="submit"
                class="btn btn--pink"
                :class="{
                    'btn--disabled': agreeOptions && !agree
                }"
            >
                {{ buttonLabel }}
            </button>
        </div>
    </form>
</template>

<script lang="ts">
    import { defineComponent, reactive, ref, toRefs } from 'vue'
    import formCheckbox from '@components/form/formCheckbox.vue'

    interface emiter {
        agree: boolean
    }

    export default defineComponent({
        components: {
            formCheckbox
        },
        props: {
            action: {
                type: Function,
                required: true
            },
            buttonLabel: {
                type: String,
                required: true
            },
            alignButton: {
                type: String,
                required: false,
                default: 'center',
                in: ['left', 'center', 'right']
            },
            errorMessage: {
                type: String,
                required: false,
            },
            gdprOptions: {
                type: Object,
                required: false
            },
            agreeOptions: {
                type: Object,
                required: false
            },
            agreeValue: {
                type: Boolean,
                required: false
            }
        },
        setup(props, { emit }) {
            const emiter = reactive<emiter>({
                agree: props.agreeOptions?.value || false
            })

            const agreeChange = (value: boolean) => {
                emiter.agree = value
                emit('update:modelValue', { ...emiter })
            }

            return {
                ...toRefs(emiter),
                agreeChange
            }
        }
    })
</script>
